import type { CSSProperties } from 'react';

/**
 * HW-701: shared fill style for absence chips/bars in the calendar views.
 * Approved renders as a solid colour fill with white content; pending renders
 * as an outline (transparent fill, coloured border) with content in the type
 * colour. Icons (lucide, `stroke="currentColor"`) and text inherit the
 * container's `color`, so callers only spread these onto the container element
 * and size/shape classes stay local to each call site.
 */
export function absenceFillStyle(
  color: string,
  isPending: boolean
): { className: string; style: CSSProperties } {
  return isPending
    ? { className: 'border bg-transparent', style: { borderColor: color, color } }
    : { className: 'text-white', style: { backgroundColor: color } };
}
